class ProductConditionSwitcher extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-condition-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-condition-panel]'));
    this.currentTab = this.querySelector('[data-condition-current="true"]');

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.selectButton(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    this.closePanels();
  }

  selectButton(selectedTab) {
    const panelId = selectedTab.getAttribute('aria-controls');
    const targetPanel = panelId ? this.panels.find((panel) => panel.id === panelId) : null;

    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.classList.toggle('is-active', isSelected);
      tab.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      tab.setAttribute('aria-expanded', isSelected && targetPanel ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isOpen = panel === targetPanel;
      panel.classList.toggle('is-active', isOpen);
      panel.hidden = !isOpen;
    });

    if (!targetPanel) this.closePanels();
  }

  closePanels() {
    this.panels.forEach((panel) => {
      panel.classList.remove('is-active');
      panel.hidden = true;
    });

    this.tabs.forEach((tab) => {
      const isCurrent = tab === this.currentTab;
      tab.classList.toggle('is-active', isCurrent);
      tab.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
      tab.setAttribute('aria-expanded', 'false');
    });
  }

  onKeydown(event, index) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();

    let nextIndex = index;
    if (event.key === 'ArrowLeft') nextIndex = index - 1;
    if (event.key === 'ArrowRight') nextIndex = index + 1;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    if (nextIndex < 0) nextIndex = this.tabs.length - 1;
    if (nextIndex >= this.tabs.length) nextIndex = 0;

    this.tabs[nextIndex].focus();
    this.selectButton(this.tabs[nextIndex]);
  }
}

if (!customElements.get('product-condition-switcher')) {
  customElements.define('product-condition-switcher', ProductConditionSwitcher);
}
